var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./SkeletonLarge.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5afb4634\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SkeletonLarge.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Skeleton/SkeletonLarge/SkeletonLarge.vue.html
// module id = Ebui
// module chunks = 2